import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "../assets/treeview.css";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
Vue.use(Vuetify);
